import axios from 'axios';

class Listing {
    #controller;
    #container;

    constructor(container) {
        this.#container = container;
        this.#registerEvents();
    }

    update(data = null) {
        this.#container.classList.add('is-loading');

        if (data !== null) {
            this.#populateFilter(data);
        }

        if (this.#controller) {
            this.#controller.abort();
        }
        this.#controller = new AbortController();

        const updateHistory = data === null;

        if (data === null) {
            data = this.#data();
        }
        const url = this.#url(data);

        axios.get(url, {
            signal: this.#controller.signal,
        })
            .then((response) => {
                this.#container.innerHTML = response.data;
                this.#container.classList.remove('is-loading');

                if (updateHistory) {
                    window.history.pushState({
                        action: 'update-listing',
                        data: data,
                    }, "", url);
                }
            });
    }

    #url(data) {
        const baseUrl = window.location.pathname;

        if (!Object.keys(data).length) {
            return baseUrl;
        }

        return baseUrl + '?' + this.#jsonToQueryString(data);
    }

    #data() {
        let data = this.#queryStringToJson();
        const filterData = this.#getFilterData();

        // merge filter data into data
        for (const [key, value] of filterData.entries()) {
            if (value === '' || value === '0') {
                delete data[key];
                continue;
            }

            data[key] = value;
        }

        return data;
    }

    #jsonToQueryString(data) {
        const params = [];

        for (const [key, value] of Object.entries(data)) {
            if (typeof value === 'string' || typeof value === 'number') {
                const param = encodeURIComponent(key) + '=' + encodeURIComponent(value);
                params.push(param);
            }
        }

        return params.join('&');
    }

    #getFilterData() {
        const filterForm = document.querySelector('#filter');
        return new FormData(filterForm);
    }

    #queryStringToJson() {
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        const params = {};
        for (const [key, value] of urlParams.entries()) {
            params[key] = value;
        }
        return params;
    }

    #populateFilter(data) {
        const form = document.querySelector('#filter');

        // Update checkboxes
        const checkboxes = form.querySelectorAll('input[type="checkbox"]');
        checkboxes.forEach((checkbox) => {
            checkbox.checked = data[checkbox.name] === checkbox.value;
        });

        // Update radios
        const radios = form.querySelectorAll('input[type="radio"]');
        radios.forEach((radio) => {
            if (radio.value === '' && data[radio.name] === undefined) {
                radio.checked = true;
                return;
            }
            radio.checked = data[radio.name] === radio.value;
        });
    }

    #registerEvents() {
        const filterForm = document.querySelector('#filter');
        filterForm.addEventListener('change', () => this.update());

        window.onpopstate = (event) => {
            const data = event.state === null ? {} : event.state.data;
            this.update(data);
        };
    }
}

const listingContainer = document.querySelector('.tariff-listing-container');
if (listingContainer) {
    const listing = new Listing(listingContainer);
    window.updateListing = () => listing.update()
}
